/**
 * Format a timestamp or Date as a local datetime string for HTML datetime-local inputs
 * Avoids timezone offset issues by using local time components instead of toISOString()
 * @param value - Unix timestamp in milliseconds or Date object
 * @returns Formatted string (YYYY-MM-DDTHH:mm) or null if no value
 */
export const formatDateTimeLocal = (value: number | Date | undefined): string | null => {
  if (!value) return null;
  const d = value instanceof Date ? value : new Date(value);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};
